import axios from "axios";
import { API_IP } from "../env";
// Set your API's base URL
const API_URL = `${API_IP}/api`;

// Helper function to get the auth header
const getAuthHeaders = (token) => ({
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

/**
 * Gets all bookings from the admin endpoint
 *
 */
export const getAdminBookings = (token, page = 1, limit = 15, search = "") => {
  // Add search as a query parameter
  return axios.get(
    `${API_URL}/admin?page=${page}&limit=${limit}&search=${encodeURIComponent(
      search
    )}`,
    getAuthHeaders(token)
  );
};

/**
 * Gets all providers from the admin endpoint
 *
 */
export const getAllProviders = (token) => {
  return axios.get(`${API_URL}/admin/providers`, getAuthHeaders(token));
};

/**
 * Updates a booking's provider
 *
 */
export const updateBookingProvider = (token, booking_id, provider_id) => {
  const payload = {
    booking_id,
    provider_id, // This will trigger the provider change logic
  };
  return axios.patch(`${API_URL}/admin`, payload, getAuthHeaders(token));
};

/**
 * Confirms or Unconfirms a booking on behalf of a provider
 *
 * @param {string} token - Admin JWT
 * @param {string} booking_id - The booking to update
 * @param {boolean} acceptanceStatus - true to confirm, false to unconfirm
 */
export const updateBookingConfirmation = (
  token,
  booking_id,
  acceptanceStatus
) => {
  const payload = {
    booking_id,
    acceptanceStatus, // This will trigger the acceptance logic
  };
  return axios.patch(`${API_URL}/admin`, payload, getAuthHeaders(token));
};
